import { TableSort } from "@kyan/ui";
import moment from "moment";

import { type OpenOrder } from "#/types/orders";
import { getOptionInstrumentProperties } from "#/utils/instrument.utils";

export const getOptionOpenOrderRows = (
  optionOpenOrders: OpenOrder[],
  sort: TableSort<OpenOrder>,
) => {
  return {
    rows: Object.entries(
      optionOpenOrders.reduce<Record<string, OpenOrder[]>>((acc, order) => {
        (acc[order.maturity] ??= []).push(order);
        return acc;
      }, {}),
    )
      .map(([maturity, orders]) => ({
        isOption: true,
        instrument: maturity,
        maturity,
        size: 0,
        direction: orders[0].direction,
        limitPrice: 0,
        filled: 0,
        orderId: orders[0].orderId,
        tif: orders[0].tif,
        date: orders[0].date,
        subOpenOrders:
          sort.key === "instrument"
            ? orders.toSorted((a, b) => {
                const { strike: strikeA, optionType: optionTypeA } =
                  getOptionInstrumentProperties(a.instrument);
                const { strike: strikeB } = getOptionInstrumentProperties(
                  b.instrument,
                );

                if (strikeA === strikeB) return optionTypeA === "call" ? -1 : 1;

                return sort.order === "asc"
                  ? strikeA - strikeB
                  : strikeB - strikeA;
              })
            : orders,
        isLiquidated: false,
      }))
      .sort((a, b) =>
        moment(a.maturity, "DDMMMYY").diff(moment(b.maturity, "DDMMMYY")),
      ),
    dataLength: optionOpenOrders.length,
  };
};
